module.exports = __webpack_public_path__ + "static/lightning-carousel-itemsPerPanel-29ee77efd127badc4acbe3f3efa91a56.png";